/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_TitleInputs */

const en_serve_faq_title = /** @type {(inputs: Serve_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions people ask`)
};

const id_serve_faq_title = /** @type {(inputs: Serve_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang sering ditanyakan`)
};

/**
* | output |
* | --- |
* | "Questions people ask" |
*
* @param {Serve_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_title = /** @type {((inputs?: Serve_Faq_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_title(inputs)
	return en_serve_faq_title(inputs)
});